<template>
  <div class="card mt-4">
    <div class="card-header">
      <div class="row">
        <div class="col-8">
          <h4>Receptura</h4>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div>
        <div v-show="!isLoaded">
          <Loading ref="loadingSpinner"></Loading>
        </div>
        <div v-if="isLoaded">
          <b-row>
            <b-col sm="2" md="1" class="pt-4">
              <EcoConventionIcon :productType="recipeType" />
            </b-col>
            <b-col sm="10" md="11">
              <label>Wybierz recepturę:</label>
              <v-select label="name" class="recipe-select" :options="recepies" v-model="selectedRecipe" @input="changeItemOnList"></v-select>
            </b-col>
          </b-row>


          <b-alert v-show="recipeType === rawMaterialTypeKonwencja" show variant="warning" class="mt-4">UWAGA, PRACUJESZ Z
            KONWENCJĄ -
            OBOWIĄZUJĄ CIĘ SPECJALNE PROCEDURY</b-alert>

          <div class="container pt-2" v-if="selectedRecipe && selectedRecipe.ingredients">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Nazwa</th>
                  <th>Ilość</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ingredient in selectedRecipe.ingredients" :key="ingredient.id">
                  <td>
                    <EcoConventionIcon :productType="ingredient.productType" />
                    {{ ingredient.name }}
                  </td>
                  <td>{{ roundTo2(ingredient.weight) }} kg</td>
                </tr>
                <tr class="grid-table">
                  <td>Łączna suma</td>
                  <td>{{ roundTo2(totalSum) }} kg</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EcoConventionIcon from "../../common/ecoConventionIcon.vue";
import deliveryMixins from '../../mixins/delivery'
import Loading from "../Common/Loading";
import FloatHelperMixins from "../../mixins/floatHelper";

export default {
  components: { Loading, EcoConventionIcon },
  mixins: [deliveryMixins, FloatHelperMixins],
  props: ["recipeId"],
  computed: {
    recipeType() {
      return this.selectedRecipe !== null ? this.selectedRecipe.recipeType : 0
    },
    recepies() {
      return this.$store.state.couvertureFormData.recipes;
    },
    totalSum() {
      if (this.selectedRecipe.ingredients) {
        return this.selectedRecipe.ingredients
          .map((x) => x.weight)
          .reduce(function (a, b) {
            return a + b;
          }, 0)
          .toFixed(3);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var that = this;
    this.$store.dispatch("getCuvertureFormData").then(function () {
      that.isLoaded = true;
    });
    if (this.recipeId) {
      this.selectedRecipe = this.recepies.filter((x) => x.id == this.recipeId)[0];
    }
  },
  data() {
    return {
      isLoaded: false,
      selectedRecipe: {},

    };
  },
  methods: {
    changeItemOnList(item) {
      this.$emit("selectedRecepie", item);
    },
  },
};
</script>
